import React from "react";
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { ProductVariantAttributeWithValues, ProductVariant } from "../../types/ProductVariant";

interface ProductVariantSelectorProps {
    variantAttributes: ProductVariantAttributeWithValues[];
    selectedAttributes: Record<string, string>;
    selectedVariant: ProductVariant | null;
    onChange: (attributeId: string, valueId: string) => void;
}

export default function ProductVariantSelector({
    variantAttributes,
    selectedAttributes,
    selectedVariant,
    onChange
}: ProductVariantSelectorProps) {
    if (!variantAttributes || variantAttributes.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mb: 3 }}>
            {variantAttributes.map(attr => (
                <Box key={attr.idProductoAtributo} sx={{ mb: 2 }}>
                    <Typography
                        sx={{
                            mb: 0.5,
                            fontFamily: "'Rubik', sans-serif",
                            fontSize: "10px",
                            fontWeight: 500,
                        }}
                    >
                        {attr.nombreAtributo.toUpperCase()}
                    </Typography>

                    <FormControl size="small" sx={{ minWidth: "70%" }}>
                        <Select
                            value={selectedAttributes[attr.idProductoAtributo] || ""}
                            onChange={(event: SelectChangeEvent) =>
                                onChange(attr.idProductoAtributo, event.target.value as string)
                            }
                            displayEmpty
                            IconComponent={KeyboardArrowDown}
                            sx={{
                                fontFamily: "'Rubik', sans-serif",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#010101",
                                height: 40,
                                borderRadius: 0,
                                ".MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#e0e0e0",
                                    borderRadius: 0
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#9e9e9e"
                                }
                            }}
                        >
                            <MenuItem
                                value=""
                                disabled
                                sx={{
                                    fontFamily: "'Rubik', sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 300
                                }}
                            >
                                {`Seleccioná ${attr.nombreAtributo.toLowerCase()}`}
                            </MenuItem>

                            {attr.valores
                                .slice()                          // copia para no mutar el array original
                                .sort((a, b) =>
                                    a.nombreValor.localeCompare(b.nombreValor, "es", { sensitivity: "base" })
                                )
                                .map(valor => (
                                    <MenuItem
                                        key={valor.idProductoAtributoValor}
                                        value={valor.idProductoAtributoValor}
                                        sx={{
                                            fontFamily: "'Rubik', sans-serif",
                                            fontSize: "12px",
                                            fontWeight: 300
                                        }}
                                    >
                                        {valor.nombreValor}
                                    </MenuItem>
                                ))}

                        </Select>
                    </FormControl>
                </Box>
            ))}

            {selectedVariant && (
                <Typography
                    sx={{
                        mt: 1,
                        fontFamily: "'Rubik', sans-serif",
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "grey.700"
                    }}
                >
                    Variante seleccionada: {selectedVariant.SKU}
                </Typography>
            )}

        </Box>
    );
}














